import axios from "axios";
import Cookies from "js-cookie";
import { ENV } from "../constants/env";
import { COOKIE_AUTH_TOKEN } from "../constants/common";

const authBaseAxios = axios.create({
  baseURL: ENV.baseApi,
});

authBaseAxios.interceptors.request.use(
  (config) => {
    const token = Cookies.get(COOKIE_AUTH_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authBaseAxios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      const errorCode = error.response?.data?.errorCode;
      Cookies.remove(COOKIE_AUTH_TOKEN);
      window.location.href = `/login?error=${errorCode}`;
    }
    if (error.response?.status === 403) {
      window.location.href = "/access-denied";
    }
    return Promise.reject(error?.response?.data);
  }
);

export default authBaseAxios;
